export default (function () {
  // Header Menu
  function documentMarginTop() {
    if ($(window).width() > 1023) {
      $('.header + section').css('margin-top', $('.header').height());
    } else {
      $('.header + section').css('margin-top', '0');
    }
  }
  $('.toggle-menu').click(function (e) {
    $('body').toggleClass('open-nav');
    $('.header').find('li').removeClass('sub-menu-opened');
    $('body').removeClass('open-sub-menu');
  });
  $('.open-sub-menu').click(function (e) {
    $(this).parents('li').addClass('sub-menu-opened');
    $('body').addClass('open-sub-menu');
  });
  $('.sub-menu-wrapper').click(function (e) {
    if ($(e.target).is('.sub-menu-wrapper') || $(e.target).is('.close-sub-menu svg')) {
      $(this).parents('li').removeClass('sub-menu-opened');
      $('body').removeClass('open-sub-menu');
    }
  });
  documentMarginTop();
  $(window).resize(function () {
    documentMarginTop();
  });
  $(window).scroll(function () {
    var scroll = $(window).scrollTop();
    if (scroll >= 10) {
      $('header').addClass("small");
    } else {
      $('header').removeClass("small");
    }
    if (scroll >= 100) {
      $('body').addClass("scrolled");
    } else {
      $('body').removeClass("scrolled");
    }
  });
});